var _style, _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    baseProfile: "tiny-ps",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 19 20",
    width: 19,
    height: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Vector-svg") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "\n\t\ttspan { white-space:pre }\n\t\t.shp0 { fill: none;stroke: #707070;stroke-width: 1.5 } \n\t")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Layer",
    className: "shp0",
    d: "M1.3 16.25L16.8 16.25C17.57 16.25 18.09 15.64 18.1 15C18.1 14.71 0.75 14.99 0.75 14.99C0.75 14.89 0.78 14.78 0.89 14.67C0.93 14.63 0.98 14.58 1.03 14.53C1.41 14.14 1.97 13.58 2.43 12.67C2.96 11.64 3.34 10.22 3.34 8.13C3.34 5.48 5.25 3.33 7.9 2.8L8.51 2.68L8.51 2.06L8.51 1.25C8.51 1 8.73 0.75 9.05 0.75C9.37 0.75 9.59 1 9.59 1.25L9.59 2.06L9.59 2.68L10.19 2.8C12.85 3.33 14.76 5.48 14.76 8.13C14.76 10.22 15.14 11.64 15.67 12.67C16.13 13.58 17.23 14.58 17.6 14.96C17.65 15.01 0.75 15.24 0.75 14.99C0.75 14.99 0.52 16.25 1.3 16.25ZM10.7 18.25C10.41 18.83 9.79 19.25 9.05 19.25C8.3 19.25 7.68 18.83 7.39 18.25L10.7 18.25Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/Notification.cab5b15c7f72b98d2cdd0860d2620d91.svg";
export { ForwardRef as ReactComponent };